<template>
  <div id="app" v-cloak>
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {};
  },
  methods: {},
  mounted() {},
};
</script>
<style>
[v-cloak] {
  display: none;
}
.el-popup-parent--hidden {
  padding-right: 0 !important;
}
</style>
